import { useShellStore } from "@/features/shell/stores/shellStore";
import {
  useBiometrics,
  useIsBiometricsEnabled,
} from "@/features/auth/hooks/useBiometrics";
import { getBiometricChallenge } from "@/features/auth/services/biometrics";
import { getBridge } from "@/utilities/bridge";
import { isWebView } from "@/utilities/display";

export const useSignIn = () => {
  const { isEnabled: isFFEnabled } = useIsBiometricsEnabled();
  const setModal = useShellStore((state) => state.setModal);
  const setIsBiometricProcessing = useShellStore(
    (state) => state.setIsBiometricProcessing,
  );
  const isBiometricProcessing = useShellStore(
    (state) => state.isBiometricProcessing,
  );
  const { sign } = useBiometrics();

  const handleSignIn = async () => {
    if (!isWebView() || !isFFEnabled) {
      setModal("signIn");
      return;
    }

    // refresh store for next call
    getBridge().send.requestBiometricAvailability();

    // read availability fresh from the store rather than subscribing at render time
    const { available, enrolled } =
      useShellStore.getState().deviceBiometricAvailability;

    if (!available || !enrolled) {
      setModal("signIn");
      return;
    }

    if (useShellStore.getState().isBiometricProcessing) return;

    setIsBiometricProcessing(true);
    const result = await getBiometricChallenge();

    if (!result.ok) {
      setIsBiometricProcessing(false);
      setModal("signIn");
      return;
    }

    sign(result.data.challenge, result.data.challengeId);
  };

  return {
    handleSignIn,
    isBiometricProcessing,
    isBiometricsEnabled: isFFEnabled,
  };
};
